<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="StockExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable :loadingTable="false" @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="680px" title="新增用户" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<block v-for="(item , index) of fromdataadd" :key="index">
					<Commondropdownlist :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
						:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max">
					</Commondropdownlist>
				</block>
			</div>
		</DialogFrom>
		<DialogFrom width="680px" title="修改用户" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<block v-for="(item , index) of fromdataedit" :key="index">
					<Commondropdownlist :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize"
						:color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max">
					</Commondropdownlist>
				</block>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该菜单吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用该菜单吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			tableDataMD: {
				type: Array,
				default: Array
			},
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				rightboo: false,
				dwonleft: false,
				ptype: '',
				fromdataadd: [],
				fromdataedit: [],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50
					},
					{
						prop: 'AccId',
						label: '账套编号',
						columnwidth: 80
					},
					{
						prop: 'AccName',
						label: '账套名称',
						columnwidth: 80
					},
					{
					  prop: 'cInvCode',
					  label: '产品编码',
					  columnwidth: 120
					},
					{
						prop: 'cInvStd',
						label: '产品代码',
						columnwidth: 104
					},
					{
						prop: 'cInvName',
						label: '产品名称',
						columnwidth: 130
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 130
					},
					{
						prop: 'ValiDate',
						label: '有效期至',
						columnwidth: 100
					},
					// {
					//   prop: 'InvClassName',
					//   label: '产品线',
					//   columnwidth: 80
					// },
					{
						prop: 'LEVEL1',
						label: 'LEVEL1',
						columnwidth: 100
					},
					{
						prop: 'LEVEL2',
						label: 'LEVEL2',
						columnwidth: 100
					},
					{
						prop: 'LEVEL3',
						label: 'LEVEL3',
						columnwidth: 100
					},
					{
						prop: 'LEVEL4',
						label: 'LEVEL4',
						columnwidth: 100
					},
					{
						prop: 'cComUnitName',
						label: '单位',
						columnwidth: 60
					},
					{
						prop: 'iQuantity',
						label: '现存量',
						columnwidth: 80
					},
					{
						prop: 'fOutQuantity',
						label: '待出库量',
						columnwidth: 80
					},
					{
						prop: 'fTransOutQuantity',
						label: '调拨待出库量',
						columnwidth: 100
					},
					{
						prop: 'fDisableQuantity',
						label: '不合格数量',
						columnwidth: 100
					},
					{
						prop: 'fPlanQuantity',
						label: '计划备料数量',
						columnwidth: 100
					},
					{
						prop: 'fInQuantity',
						label: '待入库数量',
						columnwidth: 100
					},
					{
						prop: 'fTransInQuantity',
						label: '调拨在途数量',
						columnwidth: 100
					},
					{
						prop: 'iAvailableQuantity',
						label: '可用数量',
						columnwidth: 80
					},
					{
						prop: 'StandardCost',
						label: '参考价格',
						columnwidth: 80
					},
					{
						prop: 'StandardSum',
						label: '参考价格合计',
						columnwidth: 100
					},
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == 24) {
						this.qus = item.Nodes[3].Nodes
					}
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						}
					})
				}
			},
			onRowClick(val) {
				this.rowboo = true
				//console.log(val, "val")
				this.$emit("onRowClick", val)
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			StockExport() {
				this.$emit('StockExport')
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			commclick(type) {
				this[type] = true
			},

			adduser() {
				this.dialogVisibles = true
				//console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			update() {
				this.dialogVisiblesedit = true
			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.dialogVisiblesedit = false
			},
			del() {
				this.dialogVisibledel = true
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.dialogVisibledel = false
			},
			deactivate() {
				this.dialogVisibledeactivate = true
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.dialogVisibledeactivate = false
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>
